import { endOfDay, startOfDay, subDays } from 'date-fns'
import { useEffect } from 'react'

import { useFilters, useSearchParams } from '@/hooks'
import { PackagesFilters } from '@/pages/packages/packages-list/packages-list.constants'

interface UseDefaultFilteringProps {
  searchParams: ReturnType<typeof useSearchParams>
  filters: ReturnType<typeof useFilters<PackagesFilters>>
}

// Note: Returns whether the default date-range/sort have been resolved yet (either provided
// explicitly in the URL, or applied below) - callers use this to gate their queries so the
// dashboard/counts requests aren't fired once without the defaults and again right after,
// which otherwise fires twice for every page load (the first one gets cancelled, but still
// hits the network).
export const useDefaultFiltering = ({ searchParams, filters }: UseDefaultFilteringProps) => {
  const areDefaultsResolved = Boolean(
    searchParams.parsedQuery.fromDate ||
      searchParams.parsedQuery.toDate ||
      searchParams.parsedQuery.sortBy ||
      searchParams.parsedQuery.sortOrder,
  )

  useEffect(() => {
    if (areDefaultsResolved) return

    filters.setFilters((prev) => ({
      ...prev,
      fromDate: startOfDay(subDays(new Date(), 30)).getTime(),
      sortBy: 'checkinAt',
      sortOrder: 'desc',
      toDate: endOfDay(new Date()).getTime(),
    }))
  }, [areDefaultsResolved])

  return areDefaultsResolved
}
